/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const EMPLOYEE_CAN_ABILITY = [
  ['read', 'MyProfile'],
  ['read', 'Application'],
  ['read', 'DraftAppList'],
  ['read', 'ApplicationStatus'],
  ['read', 'SubmittedAppList'],
  ['read', 'RejectedAppList'],
  ['read', 'ApplicationDetail'],
  ['read', 'NotFound'],
  ['read', 'Payment'],
  ['read', 'PaymentSuccess'],
  ['read', 'PaymentFailure'],
  ['read', 'ApprovedApplication'],
  ['read', 'MissingInfo'],
  ['read', 'PendingPayment'],
  ['read', 'CSMECertificateList'],
  ['read', 'MarriageCertificateList'],
  ['read', 'InviteAccepted'],
  ['read', 'InviteRejected'],
  ['read', 'InviteStatus'],
  ['read', 'InviteExpired'],
];

export const EMPLOYEE_CANNOT_ABILITY = [
  ['read', 'OrganizationProfile'],
  ['read', 'MasterAdminInvite'],
  ['read', 'OrgAdminList'],
  ['read', 'EmployeeList'],
  ['read', 'PaymentHistory'],
];
